var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative" },
    [
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          {
            ref: "tableheader",
            staticClass: "clearfix",
            attrs: { slot: "header" },
            slot: "header",
          },
          [
            _c(
              "el-tabs",
              {
                model: {
                  value: _vm.loginType,
                  callback: function ($$v) {
                    _vm.loginType = $$v
                  },
                  expression: "loginType",
                },
              },
              _vm._l(_vm.headeNum, function (item, index) {
                return _c("el-tab-pane", {
                  key: index,
                  attrs: { label: item.name, name: item.type.toString() },
                })
              }),
              1
            ),
            _vm._v(" "),
            _c("div", [
              _c("div", { staticStyle: { height: "1500px" } }, [
                _c("iframe", {
                  staticStyle: {
                    width: "100%",
                    height: "100%",
                    border: "0px",
                    margin: "0",
                  },
                  attrs: {
                    src: "https://console-docs.apipost.cn/preview/d99116969d5c509f/b8d3278cdcfd3756",
                  },
                }),
              ]),
            ]),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }